
<!-- Management Tab - Always Visible -->
<div class="cmplz-management-tab cmplz-fixed-bottom-right" *ngIf="!open" style="position: fixed; bottom: 0; right: 20px; background: #007bff; color: white; padding: 10px; z-index: 9998; display: block; border-radius: 6px 6px 0 0;">
  <button class="cmplz-manage-button cmplz-blue-bg" (click)="openBanner()" style="background: transparent; color: white; border: none; padding: 0; margin: 0; cursor: pointer; display: flex; align-items: center; gap: 8px;">
    Gerir Consentimento
  </button>
</div>

<!-- Consent Banner Overlay -->
<div class="consent-banner-overlay" *ngIf="open" style="position: fixed; bottom: 60px; right: 20px; z-index: 9999;">
  <div class="consent-banner">
    <div class="consent-banner-header">
      <div class="consent-banner-title">
        <h3>Gerir o Consentimento de Cookies</h3>
        <p>Para fornecer as melhores experiências, usamos tecnologias como cookies para armazenar e/ou aceder a informações do dispositivo. Consentir com essas tecnologias nos permitirá processar dados, como comportamento de navegação ou IDs exclusivos neste site. Não consentir ou retirar o consentimento pode afetar negativamente certos recursos e funções.</p>
      </div>
      <button class="close-btn" (click)="close()" aria-label="Fechar">
        <i class="bi bi-x"></i>
      </button>
    </div>

    <div class="consent-banner-content">
      <div class="consent-categories">
        <!-- Cookies Funcionais - Obrigatórios -->
        <div class="consent-category functional-mandatory">
          <div class="category-header">
            <div class="category-info">
              <div class="category-title-row">
                <div class="category-title clickable" (click)="toggleExpanded('functional')">
                  <span>Funcionais</span>
                </div>
                <div class="category-controls">
                  <span class="always-active-text">Sempre Ativo</span>
                  <i class="bi bi-chevron-down expand-icon" 
                     [class.expanded]="expandedCategories['functional']"
                     (click)="toggleExpanded('functional')"></i>
                </div>
              </div>
              <div class="expanded-text" *ngIf="expandedCategories['functional']">
                <p>O armazenamento ou acesso técnico é estritamente necessário para o fim legítimo de permitir a utilização de um determinado serviço expressamente solicitado pelo assinante ou utilizador, ou para o fim exclusivo de efetuar a transmissão de uma comunicação numa rede de comunicações eletrónicas.</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Cookies Opcionais -->
        <div class="consent-category" 
             *ngFor="let cat of ['preferences', 'statistics', 'marketing']"
             [class.allowed]="isCategoryAllowed(cat)">
          <div class="category-header">
            <div class="category-info">
              <div class="category-title-row">
                <div class="category-title clickable" (click)="toggleExpanded(cat)">
                  <span>{{ getCategoryTitle(cat) }}</span>
                </div>
                <div class="category-controls">
                  <label class="toggle-switch">
                    <input type="checkbox" 
                           [checked]="isCategoryAllowed(cat)"
                           (change)="toggleCategory(cat)">
                    <span class="toggle-slider"></span>
                  </label>
                  <i class="bi bi-chevron-down expand-icon" 
                     [class.expanded]="expandedCategories[cat]"
                     (click)="toggleExpanded(cat)"></i>
                </div>
              </div>

              <div class="expanded-text" *ngIf="expandedCategories[cat]">
                <p>{{ getCategoryExpandedText(cat) }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="consent-policy-link">
        <a href="https://gs1pt.org/politica-de-cookies/#cmplz-cookies-overview" target="_blank" rel="noopener noreferrer">
          Gerir Serviços
        </a>
      </div>
    
     
    <div class="consent-banner-actions">
      <button class="consent-accept-btn" (click)="acceptAll()">
        Aceitar 
      </button>
      <button class="consent-deny-btn" (click)="acceptNecessary()">
        Negar 
      </button>
      <button class="consent-save-btn" (click)="save()">
        Guardar Preferências
      </button>
    </div>
  </div>
  
  <div class="consent-policy-links">
    <a href="https://gs1pt.org/politica-de-cookies/" target="_blank" rel="noopener noreferrer" class="policy-link">
      Política de Cookies
    </a>
    <a href="https://gs1pt.org/politica-de-privacidade/" target="_blank" rel="noopener noreferrer" class="policy-link">
      Política de Privacidade
    </a>
  </div>
</div>